import {AccountFeatureFlags} from "@/lib/types/accounts.ts";

export function checkValuesInFeatureFlags<G extends string | number | symbol>(
  featureFlags: AccountFeatureFlags[],
  featureFlagMap: Record<string, G>
): G[] {
  return Object.values(featureFlagMap).filter(
    (value) => !featureFlags.some((flag) => featureFlagMap[flag.name] === value)
  );
}

export function createFilteredObject<K extends string | number | symbol>(
  originalObject: Record<K, string>,
  keysToOmit: K[]
): Record<K, string> {
  return Object.entries(originalObject)
    .filter(([key]) => !keysToOmit.includes(key as K))
    .reduce(
      (acc, [key, value]) => {
        acc[key as K] = value as string;
        return acc;
      },
      {} as Record<K, string>
    );
}

export type Nullable<T> = T | null;
